import type { FaireProductEntity } from "../../entity_types/product";

export const p_52xekpy2vr: FaireProductEntity = {
  token: "p_52xekpy2vr",
  type: "product",
  name: "SURE THING",
  brandToken: "b_sbb9hxmx99",
  brandName: "Touchy Coffee",
  imageUrl:
    "https://cdn.faire.com/fastly/d9cf579cb278a221934ae3e0fd558e0544775a5e531ad26eeccb2aa82a869824.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3c98e6ae23f2925f7d4866b53381baca054076c663d86d83e6923d3f85bfa430.jpeg",
    "https://cdn.faire.com/fastly/0d610aed35f92016594105a483213db6daeff1af094e45a864cef00ea242c3c1.jpeg",
    "https://cdn.faire.com/fastly/fc26bc5370b880d85838ad3a69308592876cf3830fea1a131f865962f44a7d45.jpeg",
  ],
  priceDollars: 13.2,
  description:
    "Good For: Espresso\nTaste Notes: Candy Bar, Velvety, Reliable\nPull It:\n18–20g in, 32–38g out, 26–36 sec. Tiger stripes optional, satisfaction guaranteed.\nSizing: Available in 12oz retail bags or 2lb + 5lb bulk bags for brewing!\n\nSome heroes wear capes. Ours wears crema.\nSure Thing is the pull-and-go espresso with the Touchy Coffee magic touch. Roasted to that just-right sweet spot (think cocoa-dusted brownies, roasted almond butter, and a caramel finish that lingers like a mic-drop), we built it for bar crew consistency and home-machine glory alike.\n\nThe origin rotates, but the flavor blueprint is locked: classic nutty, semi-sweet dark chocolate and caramel base + a little Touchy Coffee magic. The biggest surprise will be how good every single shot tastes.\n\nVibe Notes:\n• Milk-Chocolate Hug\n• Candied Hazelnut Crunch\n• Brown Sugar Oath\n\nP.S.\nSure Thing is our trusty year-round espresso. The coffee inside may change, but the dialed-in, dark chocolatey, caramel sweet profile never does. Stickers on each bag keep you clued in to the current origin.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:06.851Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
